export var MY_MEDICAL_MAKE_A_CLAIM = "My Medical - Make A Claim";
export var MY_MEDICAL_POPUP = function (popupTitle) { return "My Medical - Popup - " + popupTitle; };
export var MY_MEDICAL = "My Medical";
export var ACTIVATION_CODE = "Activation Code";
